export var DEFAULT_NAMESPACE = '/';
export var ACTION_TYPE_DELIMITER = '||';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/constants.js
// module id = 190
// module chunks = 7